import {
  createSlice,
  type PayloadAction,
  type Reducer,
} from '@reduxjs/toolkit';
import {
  type Market,
  MarketStatus,
  type UserSelectionExposure,
} from '../types';

export const MARKET_SLICE_KEY = 'market';

export interface MarketSliceState {
  markets: Market[];
  selectionExposure: UserSelectionExposure;
  blockedMarketIds: string[];
}

const initialState: MarketSliceState = {
  markets: [],
  selectionExposure: {
    userId: 0,
    roundId: '',
    gameId: '',
    selectionExposures: [],
  },
  blockedMarketIds: [],
};

const marketSlice = createSlice({
  name: MARKET_SLICE_KEY,
  initialState,
  reducers: {
    setMarkets: (state, action: PayloadAction<Market[]>) => {
      state.markets = action.payload.sort((a, b) => a.sortOrder - b.sortOrder);
    },
    clearOldRoundMarkets: (
      state,
      action: PayloadAction<string | undefined>
    ) => {
      state.markets = state.markets.filter((m) => m.gameId === action.payload);
    },
    updateMarkets: (state, action: PayloadAction<Market>) => {
      const roundId = action.payload.roundId;
      // Filter to this round first, then find the index in that array.
      // An index from the full list points at the wrong slot.
      const markets = state.markets.filter((m) => m.roundId === roundId);
      const index = markets.findIndex((m) => m.id === action.payload.id);
      if (index === -1) {
        markets.push(action.payload);
      } else {
        markets[index] = action.payload;
      }
      const newMarkets = markets.sort((a, b) => a.sortOrder - b.sortOrder);
      state.markets = newMarkets;
      state.blockedMarketIds = newMarkets
        .filter((m) => m.status === MarketStatus.LOCKED)
        .map((m) => m.id);
    },
    setSelectionExposure: (
      state,
      action: PayloadAction<UserSelectionExposure>
    ) => {
      state.selectionExposure = action.payload;
    },
    resetMarketSlice: () => initialState,
  },
});

const marketReducer = marketSlice.reducer as Reducer;
export default marketReducer;

export const marketSelector = (state: {
  [MARKET_SLICE_KEY]: MarketSliceState;
}) => state[MARKET_SLICE_KEY];

export const marketActions = marketSlice.actions;
